module.exports = __webpack_public_path__ + "images/218dd5b1eebab7156bd3fe6704d4b6d3.webp";